export default "__VITE_ASSET__Lo$o2ZHd__"